const convertTimezone = (dateTime) => {
    var  date = new Date(dateTime);
    return date.toLocaleDateString() + " , " + date.toLocaleTimeString();
}

export default convertTimezone